import { Injectable } from '@angular/core';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalCommunication {
  private logout: Subject<void> = new Subject();

  public emitLogout(): void {
    this.logout.next();
  }

  public getLogoutEmitter(): Observable<void> {
    return this.logout.asObservable();
  }

  constructor(private messageService: MessageService) {}

  public showMessages(messages: ToastMessageOptions[]) {
    this.messageService.addAll(messages);
  }

  public showSuccess(message: string) {
    this.messageService.add({ severity: 'success', detail: message });
  }

  public showError(message: string) {
    this.messageService.add({ severity: 'error', detail: message });
  }

  public showErrors(messages: string[]) {
    this.messageService.addAll(messages.map((message: string) => ({ severity: 'error', detail: message })));
  }
}
